import * as React from 'react';
import classNames from 'classnames';

import { Style as StyleService } from '../../../../services/styles';

/**
 * Renders an admissible drop location for the icon.
 */
export class IconArea extends React.PureComponent {
    constructor(props) {
        super(props);
        this.onEnter = () => {
            const { onEnter } = this.props;
            if (!onEnter) {
                return;
            }
            onEnter(this.props.name);
        };
    }

    render() {
        const { value, children } = this.props;

        return (
            <div
                onMouseEnter={this.onEnter}
                className={classNames(
                    'widget-style-area__icon-drop',
                    !children && 'widget-style-area__icon-drop--free',
                    value && 'widget-style-area__icon-drop--over',
                )}
            >
                {children}
            </div>
        );
    }
}
